import React from "react";
import "../styles/PatientSearch.css";

const PatientTable = ({ patients, onSelectPatient }) => {
  return (
    <div>
      {patients.length === 0 ? (
        <p>No hay pacientes registrados.</p>
      ) : (
        <table className="patientTable">
          <thead>
            <tr>
              <th>Documento</th>
              <th>Nombre</th>
              <th>Apellido</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((patient) => (
              <tr
                key={patient.id}
                onClick={() => onSelectPatient(patient)}
                className="patientRow"
              >
                <td>{patient.document}</td>
                <td>{patient.name}</td>
                <td>{patient.surname}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PatientTable;
